export const loadPrimaryColorStyle = (mainColor) => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `https://themes.solucx.com.br/buefy?color=${encodeURIComponent(mainColor)}`;
  document.head.appendChild(link);
};
